import { render, staticRenderFns } from "./CamposArtigoPeriodico.vue?vue&type=template&id=4158b0af"
import script from "./CamposArtigoPeriodico.vue?vue&type=script&setup=true&lang=ts"
export * from "./CamposArtigoPeriodico.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports